export const getPageCopy = (isPending: boolean): { heading: string; title: string; whatMeansDesc: string } => {
  return {
    heading: isPending ? 'Your loan is transferring to' : 'Your loan has been transferred to',
    title: isPending ? 'Your loan is transferring' : 'Your loan has been transferred',
    whatMeansDesc: isPending
      ? 'who will be responsible for collecting your mortgage payments'
      : 'who will now be responsible for collecting your mortgage payments',
  };
};
